<template>
  <div>
    <app-navbar v-on:toggleDrawer="toggleDrawer"/>
    <v-navigation-drawer width="350px" v-model="drawer" absolute temporary>
      <sidebar />
    </v-navigation-drawer>
    <v-row class="main pr-5">
      <v-col class="sidebar-col" md="3" sm="0">
        <sidebar class="hidden-sm-and-down" />
      </v-col>
      <v-col md="9" sm="12" class="default-slot" > 
        <slot />
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import Sidebar from './Sidebar.vue';
import UserFeed from './UserFeed.vue';
import AppNavbar from './AppNavbar.vue';

export default Vue.extend({
  name: 'Home',
  props: {
    searchText: String,
  },
  components: {
    Sidebar,
    UserFeed,
    AppNavbar,
  },
  data: function() {
    return {
      drawer: false
    };
  },
  created: function () {
  },
  methods: {
    toggleDrawer: function () {
      this.drawer = !this.drawer
    }
  }
});
</script>